import React from 'react';
import { useTheme } from '../context/ThemeContext';

/**
 * ThemeToggle
 *
 * A compact toggle button for switching between Classic and Notebook themes.
 * Designed to fit in the header alongside CostCounter.
 */
const ThemeToggle = ({ compact = true }) => {
  const { toggleTheme, isSessionPlannerTheme } = useTheme();

  const getTooltip = () => {
    return isSessionPlannerTheme
      ? 'Switch to Classic theme'
      : 'Switch to Notebook theme';
  };

  if (compact) {
    return (
      <button
        className="lrbrain-theme-toggle-compact"
        onClick={toggleTheme}
        title={getTooltip()}
        aria-label={getTooltip()}
        type="button"
      >
        <span className="theme-icon" aria-hidden="true">
          {isSessionPlannerTheme ? '\u{1F4D3}' : '\u{1F3A8}'}
        </span>
      </button>
    );
  }

  // Full toggle variant with label
  return (
    <button
      className="lrbrain-theme-toggle-full"
      onClick={toggleTheme}
      title={getTooltip()}
      aria-label={getTooltip()}
      type="button"
    >
      <span className="theme-icon" aria-hidden="true">
        {isSessionPlannerTheme ? '\u{1F4D3}' : '\u{1F3A8}'}
      </span>
      <span className="theme-label">
        {isSessionPlannerTheme ? 'Notebook' : 'Classic'}
      </span>
    </button>
  );
};

export default ThemeToggle;
